import { gql } from '@apollo/client';

export const CRM_EMAIL_MESSAGE_FIELDS = `
    _id
    crmMessageId
    toEmail
    subject
    sourceType
    status
    outcomeReason
    openedAt
    firstClickedAt
    createdAt
`;

export const LIST_CRM_ACCOUNT_EMAILS = gql`
    query ListCrmAccountEmails($accountId: String!) {
        listCrmAccountEmails(accountId: $accountId) {
            ${CRM_EMAIL_MESSAGE_FIELDS}
        }
    }
`;

/* Company-wide CRM email settings (POGO-13734) — the general Pogozo signature
   (rich HTML, incl. a hosted logo) that fills {{PogozoSignature}}. */
export const GET_CRM_EMAIL_SETTINGS = gql`
    query GetCrmEmailSettings {
        getCrmEmailSettings {
            signature
        }
    }
`;
